export default {
  name: 'custom',
  data() {
    return {
      customList: [{
        key: 'blue',
        label: '天空蓝'
      }, {
        key: 'yellow',
        label: '日落黄'
      }, {
        key: 'green',
        label: '草原绿'
      }],
      layoutList: [{
        label: '左侧导航',
        key: 'inline'
      }, {
        label: '头部导航',
        key: 'horizontal'
      }]
    };
  },
  computed: {
    theme: {
      get() {
        return this.$store.state.setting.theme;
      },
      set(val) {
        this.$store.dispatch('setting/changeSetting', {
          key: 'theme',
          value: val,
          cache: 'THEME'
        });
        document.getElementsByTagName('body')[0].className = `vue-antd-admin-${val}Theme`;
      }
    },
    layout: {
      get() {
        return this.$store.state.setting.layout;
      },
      set(val) {
        this.$store.dispatch('setting/changeSetting', {
          key: 'layout',
          value: val,
          cache: 'LAYOUT'
        });
      }
    },
    tagShow: {
      get() {
        return this.$store.state.setting.tagShow;
      },
      set(val) {
        this.$store.dispatch('setting/changeSetting', {
          key: 'tagShow',
          value: val,
          cache: 'TAG_SHOW'
        });
      }
    },
    fixHeader: {
      get() {
        return this.$store.state.setting.fixHeader;
      },
      set(val) {
        this.$store.dispatch('setting/changeSetting', {
          key: 'fixHeader',
          value: val,
          cache: 'FIX_HEARDER'
        });
      }
    }
  },
  methods: {
    changeHeader(checked) {
      this.fixHeader = checked;
    },
    changeTag(checked) {
      this.tagShow = checked;
    },
    changeLayout(val) {
      this.layout = val.target.value;
    },
    changeTheme(val) {
      this.theme = val.target.value;
    }
  }
};